<template>
  <div class="rate-limit-counter-component">
    <svg
      class="ring-outline"
      viewBox="0 0 100 100"
    >
      <circle
        class="background"
        :class="variation"
        :r="radius"
        cx="50"
        cy="50"
      />
      <circle
        v-if="questionsRemaining > 0"
        class="foreground"
        :class="variation"
        :r="radius"
        cx="50"
        cy="50"
        :stroke-dasharray="circumference"
        stroke-dashoffset="0"
        transform="rotate(270, 50, 50)"
        :style="{ strokeDashoffset: offset }"
      />
    </svg>
    <p class="questions-remaining-text">
      {{ questionsRemaining || 0 }}
    </p>
  </div>
</template>

<script>
import RateLimitMixin from '@/mixins/rate-limit';
const radius = 45;
const circumference = radius * Math.PI * 2;
export default {
  mixins: [RateLimitMixin],
  props: {
    variation: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      radius,
      circumference,
    };
  },
  computed: {
    offset() {
      return (1 - (this.questionsRemaining / this.rateLimitingCycleCredits)) * circumference;
    },
  },
};
</script>

<style lang="scss" scoped>
$circle-size: 28px;
.rate-limit-counter-component {
  align-items: center;
  display: flex;
  height: $circle-size;
  justify-content: center;
  width: $circle-size;
  position: relative;

  .ring-outline {
    height: $circle-size;
    position: absolute;
    width: $circle-size;

    .background,
    .foreground {
      fill: none;
      stroke-width: 10;
    }

    .background {
      stroke: #bef7ff;

      &.flashcard-v2 {
        stroke: #e4e5e9;
      }
    }

    .foreground {
      stroke-linecap: 'round';
      stroke: #00dbfb;

      &.flashcard-v2 {
        stroke: #697586;
      }
    }
  }
  .questions-remaining-text {
    color: #7b7b7b;
    font-weight: $semi-bold;
    font-size: rem-calc(10);
    margin: 0;
  }
}
</style>
